import { memo } from "react";
import { Button, Box } from "@mui/material";
import { useMainContext } from "../../../../../context/useMainContext";

const AudienceCell = ({ row, col }) => {
  const { setAudienceModalOpen, setCurrentAudienceData } = useMainContext();

  const fieldMap = {
    audience_countries_full: 'country',
    audience_languages_full: 'language',
    audience_cities_full: 'city',
    audience_interests_full: 'mention'
  };

  let data;
  try {
    data = JSON.parse(row[col] || "[]");
  } catch (e) {
    console.error(e);
    return "n/a";
  }

  if (!data.length) return "n/a";

  const [firstItem] = data;
  const hasMore = data.length > 1;
  const fieldName = fieldMap[col] || 'Unknown';

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          pr: hasMore ? 2 : 0,
        }}
      >
        {firstItem[fieldName] || "Unknown"}
        <span style={{ color: "#1976d2" }}>
          {Number(firstItem.value || 0).toFixed(1)}%
        </span>
      </Box>
      {hasMore && (
        <Button
          variant="outlined"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            setAudienceModalOpen(true);
            setCurrentAudienceData({
              type: col,
              data: data,
              influencer: row.username,
            });
          }}
        >
          View All ({data.length})
        </Button>
      )}
    </>
  );
};

export default memo(AudienceCell);
